















































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { demoServer, hiddenDangerLibraryServer, performanceServer, yunnanDataViewServer } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
// import DetailsDialogA from '../box8/box-8-unit-2.vue';
import DetailsDialogB from '../box8/box-8-unit-3.vue';
import dayJs from 'dayjs';

@Component({
  components: { PagingUnit, DetailsDialogB },
  mixins: [TableStripe],
})
export default class Home extends Vue {
  private visible = false;
  private title: any = '隐患列表';
  private total: any = 0;
  private tableDataB: any = [];
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  searchTimeDanger: any = [];
  rowData: any = {};
  searchFinish: any = '';

  loading: any = false;

  finishOptions: any = [
    { label: '已完成', value: true },
    { label: '未完成', value: false },
  ];

  private mounted() {}

  private async showDialog(data: any, type: any) {
    this.rowData = data;
    this.visible = true;

    this.searchFinish = type;

    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;

    const startTime = dayJs(new Date()).format('YYYY') + '-01-01';
    const endTime = dayJs(new Date()).format('YYYY') + '-12-31';
    this.searchTimeDanger = [startTime, endTime];

    this.getDataDanger();
  }

  changeFilter() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getDataDanger();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getListData() {
    this.getDataDanger();
  }

  private getDataDanger() {
    hiddenDangerLibraryServer
      .getHazardManageList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        startDate: this.searchTimeDanger && this.searchTimeDanger[0] ? this.searchTimeDanger[0] : null,
        endDate: this.searchTimeDanger && this.searchTimeDanger[1] ? this.searchTimeDanger[1] : null,
        finishFlag: this.searchFinish,
        initiateDepartmentId: this.rowData.handleDepartmentId,
        hazardLevels: this.rowData.hazardLevel,
      })
      .then((res: any) => {
        this.loading = false;
        this.tableDataB = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  showDetailDanger(data: any) {
    const DetailsDialogRef: any = this.$refs['DetailsDialogRefB'];
    DetailsDialogRef.showDialog(data);
  }
  private hideDialog() {
    this.visible = false;
  }
}
